module.exports = __webpack_public_path__ + "static/media/sheild.2d631954.png";